module.exports = __webpack_public_path__ + "img/hakuna_p01_img02.79f3551e.jpg";